import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { GroupLayer } from '@/model/document2/page/surface/design/layer/groupLayer';
import { NumberLayer } from '@/model/document2/page/surface/design/layer/numberLayer';

// グループにレイヤーを追加する
// * NewLayerCommandは余計なことをしすぎなので分離した。
export class AddLayerCommand implements ICommandBase
{
    private child! : Layer;
    private parent! : GroupLayer;
    private doneCallback! : () => void;

    constructor(child: Layer, parent: GroupLayer, doneCallback: () => void = () => {})
    {
        this.child = child;
        this.parent = parent;
        this.doneCallback = doneCallback;
    }

    public do(): void
    {
        this.parent.addLayer(this.child);
        // 連番文字対応
        if(this.child instanceof NumberLayer) { this.child.updateDocument(true); }

        this.doneCallback();
    }

    public undo(): void
    {
        this.parent.removeLayer(this.child);
        // 連番文字対応
        if(this.child instanceof NumberLayer) { this.child.updateDocument(false); }

        this.doneCallback();
    }

    public redo(): void
    {
        this.do();
    }
}